import { apiSlice } from 'store/slices/api/api-slice';
import { ImageSuccessResponse } from 'types/card/card-sphere';
import { CategoryImagesRequest } from 'types/toont-tint/toon-tint';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        categoryImageUpdate: builder.mutation<
            ImageSuccessResponse,
            CategoryImagesRequest
        >({
            query: (categoryImagesRequest: CategoryImagesRequest) => ({
                url:
                    `/toon-tint/add-category-image/` +
                    categoryImagesRequest.categoryId,
                method: 'POST',
                body: categoryImagesRequest.image,
                header: {},
            }),
        }),
    }),
});

export const { useCategoryImageUpdateMutation } = importTradeDataApiSlice;
